module.exports = __webpack_public_path__ + "assets/GoogleSans-Regular.76443cc3d5958084bbca000acb486d71.ttf";